import Alpine from 'alpinejs';

import Swiper from 'swiper';
import { Keyboard, Navigation } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';

// import styles bundle
import 'swiper/css';
import 'swiper/css/pagination';


document.addEventListener('alpine:init', () => {
    Alpine.data('lastArticleSlider', (hasMerch: unknown = false) => ({
        swiper: null as Swiper | null,
        activeSlug: null as string | null,
        async filter(slug: string | null) {
            this.activeSlug = slug;
            const url = slug
                ? `/api/blog/last-articles/${slug}/`
                : '/api/blog/last-articles/';
            const response = await fetch(url);
            if (response.ok) {
                this.$refs.posts.innerHTML = await response.text();
            }
            if (this.swiper) {
                this.swiper.update();
                this.swiper.slideTo(0);
            }
        },
        init() {
            const swiperParams: SwiperOptions = {
                modules: [Navigation, Keyboard],
                slidesPerView: 1.10,
                init: false,
                spaceBetween: 8,
                breakpoints: {
                    1024: {
                        spaceBetween: 16,
                        slidesPerView: hasMerch === true ? 2.3 : 3.3,
                    },
                },
                navigation : {
                    prevEl: this.$refs.buttonPrev,
                    nextEl: this.$refs.buttonNext,
                    disabledClass: 'bg-gray-300 !text-gray-600 pointer-events-none',
                },
                keyboard: {
                    enabled: true,
                },
            }

            const swiper = new Swiper(
                this.$refs.swiperContainer,
                swiperParams,
            );
            this.swiper = swiper;

            this.$nextTick(() => {
                swiper.init();
            });
        }
    }));
});
